<template>
  <Tooltip>
    <TooltipTrigger>
      <div class="flex items-center cursor-pointer rounded-lg hover:bg-gray-200 p-2" @click="emit('click-icon')">
        <vue-feather :class="`text-gray-500 ${mapIconSize()}`" :type="iconType" />
      </div>
    </TooltipTrigger>
    <TooltipContent>
      <p>{{ tooltip }}</p>
    </TooltipContent>
  </Tooltip>
</template>

<script setup lang="ts">
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
type WorkflowIconProps = {
  iconType: string;
  tooltip: string;
  size?: 'md' | 'lg';
};
const { size = 'md' } = defineProps<WorkflowIconProps>();

const emit = defineEmits(['click-icon']);

const mapIconSize = () => {
  return size === 'lg' ? 'w-6' : 'w-5';
};
</script>
